// extracted by mini-css-extract-plugin
export default {"autosuggest_wrapper":"DiagnosisSearch_autosuggest_wrapper__wXiOg","add_button":"DiagnosisSearch_add_button__agwlG","autosuggest_field":"DiagnosisSearch_autosuggest_field__KiKlm"};